export const documents = ['PASSPORT', 'ID']
